<div class="landing-background">
  <qm-toolbar [injectedComponent]="landingController"></qm-toolbar>
  <div class="landing-container">
    <gridster [options]="options">
      <gridster-item [item]="item" *ngFor="let item of getDashboard()">
        <div class="card" style="width: 100%; height: 100%" (mouseover)="hoverTileId = item.id"
             (mouseleave)="hoverTileId = null">
          <div class="card-title-container">
            <h5 class="card-title drag-handler">{{item.title | translate}} </h5>
            <div class="action-buttons">
              <a class="text-warning">
                <i class="far fa-xs fa-window-minimize"></i>
              </a>
              <a class="text-success" *ngIf="item.maximized" (click)="restoreTile($event, item)">
                <i class="far fa-xs fa-window-restore"></i>
              </a>
              <a class="text-success" *ngIf="!item.maximized" (click)="maximizeTile($event, item)">
                <i class="far fa-xs fa-window-maximize"></i>
              </a>
              <a class="text-danger" (click)="removeTile($event, item)">
                <i class="far fa-xs fa-window-close"></i>
              </a>
            </div>
          </div>
          <div class="card-body">
            <ng-container *ngIf="item.component; else static">
              <ng-container *ngComponentOutlet="item.component"></ng-container>
            </ng-container>
            <ng-template #static>
              <p class="card-text">This card has supporting text below as a natural lead-in to additional
                content.</p>
              <p class="card-text">
                <small class="text-muted">Last updated 3 mins ago</small>
              </p>
            </ng-template>
          </div>
        </div>
      </gridster-item>
    </gridster>
  </div>

  <qm-vrgroup-base *qmAuth="'vr-group'"></qm-vrgroup-base>
</div>
